import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { process, State, CompositeFilterDescriptor,AggregateDescriptor, aggregateBy } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { TotalSalesByDateVM, TotalSalesByYearVM, SalesByYearMonthVM, TotalSalesByMonthVM, SalesByDayOfWeekVM } from '../../interfaces/interfaces';
//import { SeriesType } from '@progress/kendo-angular-charts';

@Component({
  selector: 'app-last-seven-days',
  templateUrl: './last-seven-days.component.html',
  styleUrls: ['./last-seven-days.component.scss']
})
export class LastSevenDaysComponent implements OnInit {
  public sales: any;
  public selectedTabIndex = 0;
  dateForm: UntypedFormGroup;
  yearForm: UntypedFormGroup;
  currentYear: number = new Date().getFullYear();
  isLoading = false;
  canEdit = true;
  userName: string;

  day: string;
  month: string;
  year: string;

  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };


  public gridStateDay: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateMonth: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateYear: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateWeekCreams: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateWeekMH: State = {
    sort: [],
    skip: 0,
    take: 100,
  };

  salesByYearVm: TotalSalesByYearVM[] = [];
  salesByYearMonthVm: SalesByYearMonthVM[] = [];
  salesByMonthVm: TotalSalesByMonthVM[] = [];
  salesByDayOfWeekVm: SalesByDayOfWeekVM[] = [];
  //currentYearVm: SalesByYearVm[] = [];
  currentMonthVm: SalesByYearMonthVM[] = [];
  currentDateVm: TotalSalesByDateVM[] = [];

  currentWeekCreamsVm: TotalSalesByDateVM[] = [];
  currentWeekMHVm: TotalSalesByDateVM[] = [];

  public gridDataCurrentYear: any = process(this.salesByYearVm, this.gridStateYear);
  public gridDataCurrentMonth: any = process(this.salesByMonthVm, this.gridStateMonth);

  //public gridDataDayOfWeek: any = process(this.salesByDayOfWeekVm, this.gridState);
  public gridDataCurrentDay: any = process(this.currentDateVm, this.gridStateYear);

  public gridDataCurrentWeekCreams: any = process(this.currentWeekCreamsVm, this.gridStateWeekCreams);
  public gridDataCurrentWeekMH: any = process(this.currentWeekMHVm, this.gridStateWeekMH);

  public aggregatesDay: AggregateDescriptor[] = [
    { field: "totalSales", aggregate: "sum" },
    { field: "netSales", aggregate: "sum" },
    { field: "cashSales", aggregate: "sum" },
    { field: "cardSales", aggregate: "sum" },
    { field: "deliverySales", aggregate: "sum" },
    { field: "transactions", aggregate: "sum" },
  ];
  public aggregatesMonth: AggregateDescriptor[] = [
    { field: "totalSales", aggregate: "sum" },
    { field: "netSales", aggregate: "sum" },
    { field: "cashSales", aggregate: "sum" },
    { field: "cardSales", aggregate: "sum" },
    { field: "deliverySales", aggregate: "sum" },
    { field: "transactions", aggregate: "sum" },
  ];
  public aggregatesYear: AggregateDescriptor[] = [
    { field: "totalSales", aggregate: "sum" },
    { field: "netSales", aggregate: "sum" },
    { field: "cashSales", aggregate: "sum" },
    { field: "cardSales", aggregate: "sum" },
    { field: "deliverySales", aggregate: "sum" },
    { field: "transactions", aggregate: "sum" },
  ];
  public aggregatesWeekCreams: AggregateDescriptor[] = [
    { field: "totalSales", aggregate: "sum" },
    { field: "netSales", aggregate: "sum" },
    { field: "cashSales", aggregate: "sum" },
    { field: "cardSales", aggregate: "sum" },
    { field: "deliverySales", aggregate: "sum" },
    { field: "transactions", aggregate: "sum" },
  ];
  public aggregatesWeekMH: AggregateDescriptor[] = [
    { field: "totalSales", aggregate: "sum" },
    { field: "netSales", aggregate: "sum" },
    { field: "cashSales", aggregate: "sum" },
    { field: "cardSales", aggregate: "sum" },
    { field: "deliverySales", aggregate: "sum" },
    { field: "transactions", aggregate: "sum" },
  ];

  public totalYear: any = aggregateBy(this.gridDataCurrentYear.data, this.aggregatesYear);
  public totalMonth: any = aggregateBy(this.gridDataCurrentMonth.data, this.aggregatesMonth);
  public totalDayOfWeek: any = aggregateBy(this.gridDataCurrentDay.data, this.aggregatesDay);
  public totalDayOfWeekCreams: any = aggregateBy(this.gridDataCurrentWeekCreams.data, this.aggregatesWeekCreams);
  public totalDayOfWeekMH: any = aggregateBy(this.gridDataCurrentWeekMH.data, this.aggregatesWeekMH);

  public latestDate: string;

  public salesData: any[] = [];
  public view: [number, number] = [700, 400];
  public showXAxis = true;
  public showYAxis = true;
  public gradient = false;
  public showLegend = true;
  public showXAxisLabel = true;
  public showYAxisLabel = true;
  public xAxisLabel = 'Date';
  public yAxisLabel = 'Sales (£)';
  public colorScheme = {
    domain: ['#2196f3', '#ff9800']
  };

  constructor(
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.initializeForms();
  }

  ngOnInit(): void {
    this.userName = localStorage.getItem('currentUserName');
    this.loadLastSevenDays();
    //this.loadSalesData();
  }

  private initializeForms(): void {
    this.dateForm = this.formBuilder.group({
      getDate: [null],
    });
  }

  private loadLastSevenDays(): void {
    this.isLoading = true;
    const selectedYear = this.currentYear;
    const today = new Date();

    this.authService.getGeneralSalesDash7Days({
      day: null,
      useDay: 0,  // Last 7 days
    }).pipe(take(1)).subscribe({
      next: (response) => {
        this.sales = response;
        //this.gridData = this.sales.salesByYear; //groupBy(this.sales, this.groups);
        this.day = this.sales.totalSalesByDate[0].date.toString();
        this.month = this.sales.totalSalesByDate[0].paymentMonth.toString();
        this.year = this.sales.totalSalesByDate[0].date.toString();

        this.latestDate = response.tab1[0].latestUploadDate;

        //alert("Before Year");
        //console.log(this.totalTab1Now);
        //console.log(this.totalDayOfWeek);
        this.gridDataCurrentYear = process(this.sales.toitalSalesByYear, this.gridStateYear);
        this.totalYear = aggregateBy(this.gridDataCurrentYear.data, this.aggregatesYear);

        // //alert("Before Month");

        this.gridDataCurrentMonth = process(this.sales.totalSalesByMonth, this.gridStateMonth);
        this.totalMonth = aggregateBy(this.gridDataCurrentMonth.data, this.aggregatesMonth);

        //alert("Before Day");

        this.gridDataCurrentDay = process(this.sales.totalSalesByDate, this.gridStateDay);
        this.totalDayOfWeek = aggregateBy(this.gridDataCurrentDay.data, this.aggregatesDay);

        console.log(this.totalDayOfWeek);

        //alert("Before Week");

        this.gridDataCurrentWeekCreams = process(this.sales.totalSalesByWeekCreams, this.gridStateWeekCreams);
        this.totalDayOfWeekCreams = aggregateBy(this.gridDataCurrentWeekCreams.data, this.aggregatesWeekCreams);

        console.log(this.totalDayOfWeekCreams);

        this.gridDataCurrentWeekMH = process(this.sales.totalSalesByWeekMH, this.gridStateWeekMH);
        this.totalDayOfWeekMH = aggregateBy(this.gridDataCurrentWeekMH.data, this.aggregatesWeekMH);

        console.log(this.totalDayOfWeekMH);
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error loading sales:', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    //alert("in day");
    this.gridStateDay = state;
    this.gridDataCurrentDay = process(this.sales.totalSalesByDate, this.gridStateDay);
        this.totalDayOfWeek = aggregateBy(this.gridDataCurrentDay.data, this.aggregatesDay);
}

  getDay(): void {
    const selectedDate = this.dateForm?.get('getDate')?.value;
    const selectedYear = this.currentYear;

    if (!selectedDate) {
      console.warn('No date selected');
      return;
    }

    this.authService.getGeneralSalesDash7Days({
      day: selectedDate,
      useDay: 1,
    }).pipe(take(1)).subscribe({
      next: (response) => {
        this.sales = response;
        
        this.gridDataCurrentYear = process(this.sales.toitalSalesByYear, this.gridStateYear);
        this.totalYear = aggregateBy(this.gridDataCurrentYear.data, this.aggregatesYear);

        this.gridDataCurrentMonth = process(this.sales.totalSalesByMonth, this.gridStateMonth);
        this.totalMonth = aggregateBy(this.gridDataCurrentMonth.data, this.aggregatesMonth);

        this.gridDataCurrentDay = process(this.sales.totalSalesByDate, this.gridStateDay);
        this.totalDayOfWeek = aggregateBy(this.gridDataCurrentDay.data, this.aggregatesDay);

        this.gridDataCurrentWeekCreams = process(this.sales.totalSalesByWeekCreams, this.gridStateWeekCreams);
        this.totalDayOfWeekCreams = aggregateBy(this.gridDataCurrentWeekCreams.data, this.aggregatesWeekCreams);

        this.gridDataCurrentWeekMH = process(this.sales.totalSalesByWeekMH, this.gridStateWeekMH);
        this.totalDayOfWeekMH = aggregateBy(this.gridDataCurrentWeekCreams.data, this.aggregatesWeekCreams);

        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error in getDay:', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  private loadSalesData(): void {
    this.isLoading = true;
    this.authService.getGeneralSalesDash7Days({
      day: null,
      useDay: 0,  // Last 7 days
    }).subscribe({
      next: (response) => {
        if (response && response.tab1 && Array.isArray(response.tab1)) {
          this.salesData = [
            {
              name: 'Current Year',
              series: response.tab1.map(item => ({
                name: item.month,
                value: item.salesCurrent
              }))
            },
            {
              name: 'Last Year',
              series: response.tab1.map(item => ({
                name: item.month,
                value: item.salesLY
              }))
            }
          ];
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading sales data:', error);
        this.isLoading = false;
      }
    });
  }

  onSelect(event: any): void {
    console.log('Item clicked', event);
  }

  formatCurrency(value: number): string {
    return `£${value.toLocaleString()}`;
  }
} 